import { render, staticRenderFns } from "./PersonalDetail.vue?vue&type=template&id=21932725&scoped=true"
import script from "./PersonalDetail.vue?vue&type=script&lang=js"
export * from "./PersonalDetail.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetail.vue?vue&type=style&index=0&id=21932725&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21932725",
  null
  
)

export default component.exports